import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f40b152a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-system-search-box-root" }
const _hoisted_2 = { class: "search app-system-search-box" }
const _hoisted_3 = {
  key: 0,
  class: "suffix"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_icon = _resolveComponent("app-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _renderSlot(_ctx.$slots, "search", {}, () => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSearch
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 查询 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ], true),
      _renderSlot(_ctx.$slots, "reset", {}, () => [
        _createVNode(_component_el_button, {
          type: "info",
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 重置 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ], true),
      _renderSlot(_ctx.$slots, "more", {}, undefined, true)
    ]),
    (_ctx.isSuffix)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "suffix", {}, () => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onAdd,
              class: "add"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  readonly: true,
                  name: "icon-new"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.btnText), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ], true)
        ]))
      : _createCommentVNode("", true)
  ]))
}